import { render, staticRenderFns } from "./form-brief-create-url.vue?vue&type=template&id=5c855dce&"
import script from "./form-brief-create-url.vue?vue&type=script&lang=js&"
export * from "./form-brief-create-url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports